import React, { useState, useEffect } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import messages from '../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  lineNameField: {
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
    },
  },
}));

export default function LineNameEdit({
  line,
  setLineInfoDuringEdit,
  addOrDeleteError,
}) {
  const classes = useStyles();
  const mobile = useMobile('sm');
  const [newName, setNewName] = useState('');
  const [error, setError] = useState(false);
  validateLineName(newName, false);
  setLineInfoDuringEdit('name', newName);

  useEffect(() => {
    setNewName(line.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function validateLineName(name: string, markFieldRedOnErr: boolean = true) {
    if (!name) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        'name',
        messages.lines.lineEditErrors.nameRequired,
      );
    } else {
      markFieldRedOnErr && setError(false);
      addOrDeleteError(false, 'name');
    }
  }

  function handleNameChange(event) {
    const newName = event.target.value;
    setNewName(newName);
    setLineInfoDuringEdit('name', newName);
    validateLineName(newName);
  }

  return (
    <TextField
      inputProps={{ className: classes.lineNameField }}
      label={mobile ? 'Line name' : null}
      error={error}
      onChange={handleNameChange}
      value={newName}
    />
  );
}
